'use strict';

var util = angular.module('gymsystem.util');

util.directive('logo', [function() {
    return {
        restrict: 'E',
        template: '<img ng-src="/api/image/get?type=Logo&id={{settings.small ? 2 : 1}}" style="max-width:100%;max-height:100%;width:auto;height:auto;display: block; margin: auto; padding: 10px">',
        scope: {
            settings: '='
        },
        link: function() {
        }
    };
}]);
